import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IotDeviceManagementPortalAppState } from '../../../store/iotDeviceManagementPortalApp.reducer';

@Component({
  selector: 'top-loader',
  templateUrl: './top-loader.component.html',
  styleUrls: ['./top-loader.component.scss'],
})
export class TopLoaderComponent implements OnInit, OnDestroy {
  public topLoading$: boolean;
  private appStoreSubscription: Subscription;

  constructor(private store: Store<IotDeviceManagementPortalAppState>) {}
  ngOnDestroy(): void {
    if (this.appStoreSubscription) {
      this.appStoreSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.appStoreSubscription = this.store.select('app').subscribe((state) => {
      this.topLoading$ = state.topLoading;
    });
  }
}
